
/**
 * 将秒数格式化为时分秒
 * @param {number} seconds 秒数
 * @returns {string} 格式化后的时间字符串
 */
export const formatDuration = (seconds) => {
  if (!seconds || seconds === 0) return '0秒';

  // 确保输入是数字，并转换为整数秒
  const totalSeconds = Math.floor(Number(seconds));
  
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  let result = '';
  if (days > 0) result += `${days}天 `;
  if (hours > 0) result += `${hours}小时 `;
  if (minutes > 0) result += `${minutes}分钟 `;
  if (secs > 0 || result === '') result += `${secs}秒`;

  return result.trim();
};

 